import moment from "moment";

export const LiveOnly = [
  {
    id: 'welcome',
    type: 'letstalk',
    hideCountText: true,
  },
  {
    id: 'previouslyDiagnosed',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: true,
    sendToAthena: true,
    prompt: 'When were you diagnosed with hypothyroidism?',
    isHPI: true,
    hpiIndex: 0,
    savingSection: 'diagnosed',
    isSaveTemp: true,
    options: [
      {
        questionId: '19',
        value: 'Select a year',
        answer: 'Y',
        giveDetails: true,
        inputType: 'number',
        min: 1900,
        max: parseInt(moment().format('YYYY'), 10),
        step: 1,
      },
      {
        questionId: '19',
        value: 'I never got diagnosed',
        answer: 'N',
        goToPage: 'testFirst',
      },
    ],
    // onSubmitHandler: selectedOptions => {
    //   console.log({selectedOptions})
    //   if (selectedOptions.answer!=='N') {
    //     return '/schedule';
    //   }

    //   return null;
    // },
    hpiComputer: (selectedValues, session) => {
      let age = moment().diff(session.dob, 'years');
      const initialString = `${session.firstName} is a ${age} years old ${
        session.gender.toLowerCase() === 'f' ? 'woman' : 'man'
      }`;
      if (!selectedValues || selectedValues.answer.toLowerCase === 'no') {
        return initialString + ' who never got diagnosed. ';
      }
      let year = `on ${selectedValues.value}`;
      try {
        year = `in ${selectedValues.value.substring(0, 4)}`;
      } catch {}

      return `${initialString}, diagnosed with hypothyroidism ${year}. `;
    },
    preCheckDisplay: (session, history) => {
      if (
        session &&
        !!session.diagnoseFull &&
        !!session.diagnoseFull.hasHypo &&
        !!session.diagnoseFull.hypoNotes
      ) {
        history.push('/schedule');
      }

      return true;
    },
  },
  {
    id: 'cancerhistory',
    type: 'single',
    endpoint: 'medicalHistory',
    onlyFirstTime: true,
    sendToAthena: true,
    savingSection: 'cancerHistory',
    prompt: 'Do you or did you ever have a history of thyroid cancer?',
    options: [
      {
        questionId:
          window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 ||
          window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1
            ? '297'
            : '301',
        value: 'No',
        answer: 'N',
        goTo:'/schedule'
      },
      {
        questionId:
          window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 ||
          window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1
            ? '297'
            : '301',
        value: 'Yes',
        answer: 'Y',
        goToPage: 'disqualifiedcancer',
        placeholder: 'Tell us more',
        giveDetails: true,
        giveDetailsEnforce: true,
      },
    ],
    onSubmitHandler: selectedOptions => {
      console.log({selectedOptions})
      // if (selectedOptions.answer!=='N') {
      //   return '/schedule';
      // }

      return null;
    },
  },
  {
    id: 'testFirst',
    hideCountText: true,
    type: 'testFirst',
  },
  {
    id: 'disqualifiedcancer',
    type: 'disqualified',
    hideCountText: true,
    endpoint: 'disqualified',
    onlyFirstTime: false,
    prompt: 'disqualified',
    variant: 'cancer',
  },
];
